import { useEffect, useMemo } from 'react'
import { createOutgoingCallRingtonePlayer } from '@/lib/outgoingCallRingtone'
import { useCallStore } from '@/store/callStore'

export function useOutgoingCallRingtone() {
  const outgoingOrderID = useCallStore((state) => state.outgoingCall?.order_id || null)
  const currentOrderID = useCallStore((state) => state.currentCall?.order_id || null)
  const player = useMemo(() => createOutgoingCallRingtonePlayer(), [])

  useEffect(() => {
    if (outgoingOrderID && currentOrderID !== outgoingOrderID) {
      player.start(outgoingOrderID)
      return
    }
    player.stop()
  }, [currentOrderID, outgoingOrderID, player])

  useEffect(() => () => {
    player.destroy()
  }, [player])
}
